module.exports = __webpack_public_path__ + "app/img/turtle2_protection.f5475b9f.jpg";